// @flow

let _defaultConstructorFn = null;

/**
 * A creator of resources.
 */
const ResourceFactory = {
  /**
   * Set the default constructor for resources
   */
  setDefaultConstructorFn(ctor: ?Function) {
    _defaultConstructorFn = ctor;
  },

  /**
   * Create an instance.
   *
   * @param {string} name
   * @param {!Object.<string,*>=} options
   * // TODO(chris): Make this typing more stict again param {!ResourceOptions=} options
   * @return {!IResource}
   */
  create(name: string, options: Object = {}) {
    if (_defaultConstructorFn) {
      const resourceOptions = options || {};
      return new _defaultConstructorFn(name, resourceOptions);
    } else {
      throw new Error("Couldn't find constructor function for " + name);
    }
  },

  /**
   * Create an instance.
   *
   * @param {!ResourcePlainObject} plainObject
   * @return {!IResource}
   */
  createFromPlainObject(plainObject: { name: string, options: Object }) {
    return this.create(plainObject.name, plainObject.options);
  },
};

export default ResourceFactory;
